import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function VoucherPromptDialog({ open, onOpenChange }: Props) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Dir fehlt ein aktives Kontingent</DialogTitle>
          <DialogDescription>
            Um das Innere Team weiter zu nutzen, brauchst du einen Gutschein-Code.
          </DialogDescription>
        </DialogHeader>
        <div className="text-sm text-muted-foreground space-y-2 mt-4">
          <p>
            Du findest das Eingabefeld in deinen Einstellungen.
          </p>
          <p>
            Noch keinen Code? Schreib uns an{' '}
            <a href="mailto:hallo@teamity.io" className="text-primary underline underline-offset-2">
              hallo@teamity.io
            </a>
            {' '}— wir melden uns zeitnah bei dir.
          </p>
        </div>
        <div className="flex gap-2 justify-end mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Später</Button>
          <Button onClick={() => { onOpenChange(false); navigate('/einstellungen'); }}>
            Gutschein einlösen
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
